<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="refund()">批量申请退票</el-button>
        <el-button size="small" type="danger" @click="saleCancel()"
          v-if="['ADMIN', 'SALES_MANAGER', 'SALES'].includes(role)">批量取消开票</el-button>
        <el-button size="small" style="color:#ffffff;background-color: #779221" icon="el-icon-download"
          @click="download('', 'invoice')">批量下载发票</el-button>
        <el-button size="small" style="color:#ffffff;background-color: #779221" icon="el-icon-download"
          @click="download('all', 'invoice')">下载全部发票</el-button>
      </div>
      <export-components :apiFunction="exportInvoice" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <table-col :cols="columns" :table-col="columns" :columnType="'invoiceTableCols' + activeTab" @submit="getCheckedBox"></table-col>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :key="tabIndex" :label="item.label" :name="item.name">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="checkedCol" :table-data="tableData" @rowSelection="rowSelection($event)"
      :key="activeTab" @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      ref="wMyTable" :page="page" @pageChange="handlePagePagination($event)" :isShowRowSelection="true">
      <template slot="operation" slot-scope="{text,record}">
        <el-button size="mini" style="color:#ffffff;background-color: #779221" v-if="record.appendix"
          icon="el-icon-download" @click="download(record,'invoice')">下载发票</el-button>
        <el-button size="mini" type="primary" icon="el-icon-download" v-if="record['annexFlag']"
          @click="download(record,'record')">下载试剂清单</el-button>
        <el-button size="mini" type="success" v-if="record.auditStatus === 'DEFEAT'"
          @click="handleEdit(record)">编辑</el-button>
        <el-button size="mini" type="danger" icon="el-icon-delete" @click="refund(record)"
          v-if="!['SUCCESS'].includes(record.refundAuditStatus) && ['RECEIVABLES'].includes(record.invoiceStatus) ">
          申请退票
        </el-button>
        <el-button size="mini" type="danger" @click="saleCancel(record)"
          v-if="['PENDING_INVOICE'].includes(record.invoiceStatus) && ['ADMIN', 'SALES_MANAGER', 'SALES'].includes(role)">
          取消开票
        </el-button>
      </template>
      <template slot="connectedFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="claimTheInvoiceFlag" slot-scope="{text,record}">
        <span v-if="claimInvoiceFlag(text)" style="display: flex;align-items: center">
          <el-tag type="success"><span>是</span></el-tag>
          <el-link type="primary" style="margin-left: 5px" :underline="false" @click="openPaymentsInfo(record,true)"><i
              v-html="viewDetailIcon"></i></el-link>
        </span>
        <el-tag v-else type="danger">否</el-tag>
      </template>
      <template slot="sameDayFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="auditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['invoiceAuditRejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true"
            :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="refundAuditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="invoiceStatus" slot-scope="{text,record}">
        <div style="display: flex;align-items: center;">
          <el-tag :type="getInvoiceColor(text, 'tagType')"
            :style="{ color: getInvoiceColor(text, 'color'), 'background-color': getInvoiceColor(text, 'backgroundColor') }">
            {{ getInvoiceColor(text, 'name') }}</el-tag>
          <w-ellipsis-and-look v-if="text === 'CANCEL_INVOICING'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['cancelInvoicingReason']" :column="{ title: '取消开票原因' }" :onlyDetail="true"
            :isOpenHtml="false">
          </w-ellipsis-and-look>
          <w-ellipsis-and-look v-if="['SUCCESS','APPLYING'].includes(record.refundAuditStatus)" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['refundReason']" :column="{ title: '申请退票原因' }" :onlyDetail="true"
            :isOpenHtml="false">
          </w-ellipsis-and-look>
        </div>
      </template>
      <template slot="filterTime" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-input v-model="selectedKeys[0]" size="mini" placeholder="开始日期" style="width: 120px;">
          </el-input>
          -
          <el-input v-model="selectedKeys[1]" size="mini" placeholder="结束日期" style="width: 120px;">
          </el-input>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters,'time')">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="filterInvoice" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='应收款'>应收款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待开票'>待开票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已回款'>已回款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待退票'>待退票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='退票成功'>退票成功</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='部分到款'>部分到款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='取消开票'>取消开票</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">
            搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="createSales" slot-scope="{record}">
        <span v-if="!(record?.initialSale?.uuid)">{{ 'NA' }}</span>
        <span v-else-if="record.applicantId === record.initialSale.uuid">{{ record.initialSale.name || '系统内未找到' }}</span>
        <div v-else>
          <span style="display: block; text-align: left;">销售：{{
            record.initialSale.originalPersonMap[record.applicantId]['name'] || '系统内未找到' }}(已离职)</span>
          <span style="display: block; text-align: left;">离职时间：{{
            record.initialSale.originalPersonMap[record.applicantId]['deleteTime'] || '系统内未找到' }}</span>
        </div>
      </template>
      <template slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </template>
      <template slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <!--        <el-tooltip effect="dark" content="查看客户信息" placement="bottom">-->
        <!--          <el-link type="primary" :underline="false" @click="showContact([...new Set(text)])"><i v-html="viewDetailIcon"></i></el-link>-->
        <!--        </el-tooltip>-->
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </template>
      <template slot="paymentAmount" slot-scope="{text,record,index}" v-if="text">
        <span v-for="(payment,index1) in text.filter(item => item['paymentStatus'] === 'DONE')">
          {{payment.paymentAmount + (index1!==text.filter(item => item['paymentStatus'] === 'DONE').length-1?'/':'')}}
        </span>
      </template>
      <template slot="refundTime" slot-scope="{text,record}">
        <div v-if="text">{{text}}</div>
        <div v-else>NA</div>
      </template>
      <template slot="operatingTime" slot-scope="{text,record}">
        <div v-if="text">{{text}}</div>
        <div v-else>NA</div>
      </template>
      <template slot="refundDate" slot-scope="{text,record}">
        <div v-if="text">{{text}}</div>
        <div v-else>NA</div>
      </template>
      <template slot="paymentDate" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text"
          :scope="{text:text.filter(item => item['paymentStatus'] === 'DONE').map(item => item.paymentDate), record, index}"></ex-fold-table-cell>
      </template>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <add-record-mail v-if="showAddEditDialog" :show-dialog="showAddEditDialog" :selectType="selectType"
      :select-detail="selectDetail" @submit="closeAddEditDialog">
    </add-record-mail>
    <add-record-mail v-if="showAddRecordMail" :show-dialog="showAddRecordMail" :selectType="{type: 'add'}"
      @submit="closeAdd"></add-record-mail>
    <payments-info v-if="showPayments" :show-dialog="showPayments" :claim-infos="claimInfos" :invoice-info="ticketsInfo"
      :payments-info="paymentsInfos" @submit="closeShowPayments"></payments-info>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
  </div>
</template>

<script>
import { downloadBatch, exportInvoice, getTicketsPage, refundTickets, saleCancelInvoice } from "@/api/dilivery/tickets";
import {ticket} from "@/utils/data/tableCol/tickets/ticket";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import TableCol from "@/components/customerTable/TableCol.vue";
import {getRecordPage} from "@/api/dilivery/record";
import AddRecordMail from "@/components/record/AddRecordMail.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import _ from "lodash";
import {viewDetailIcon} from "@/utils/icon";
import {getAuditPage} from "@/api/dilivery/audit";
import PaymentsInfo from "@/components/info/payment/PaymentsInfo.vue";
import ExportComponents from "@/components/ExportComponents.vue";
import {getInvoiceColor, getStatusColor} from "@/color";
import {getUserPage} from "@/api/dilivery/customer/user";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { record } from "@/utils/data/tableCol/record/record";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "Tickets",
  components: {
    CustomerUserInfo,
    ExportComponents, PaymentsInfo, ExFoldCell, PictureLoading, AddRecordMail, TableCol, ExFoldTableCell, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部发票', name: 'all', showBadge: false },
        { label: '待审核', name: 'APPLYING', showBadge: false },
        { label: '已通过', name: 'SUCCESS', showBadge: false },
        { label: '已驳回', name: 'DEFEAT', showBadge: false },
        { label: '待开票', name: 'PENDING_INVOICE', showBadge: false },
        { label: '已开票', name: 'RECEIVABLES', showBadge: false },
        { label: '取消开票', name: 'CANCEL', showBadge: false },
        { label: '退票待审核', name: 'refundAuditStatus', showBadge: false },
        { label: '待退票', name: 'PENDING_REFUND', showBadge: false },
        { label: '退票成功', name: 'REFUND_SUCCESS', showBadge: false },
        { label: '3个月未到款发票', name: 'THREE_MONTHS_UNPAID_INVOICE', showBadge: false },
        { label: '6个月未到款发票', name: 'SIX_MONTHS_UNPAID_INVOICE', showBadge: false },
      ],
      sendData: {
        all: {},
        APPLYING: { "statusType": "APPLYING" },
        SUCCESS: { "statusType": "SUCCESS" },
        DEFEAT: { "statusType": "DEFEAT" },
        PENDING_INVOICE: { "query#invoiceStatus.EQ": "PENDING_INVOICE" },
        RECEIVABLES: { "query#invoiceStatus.IN": "RECEIVABLES,PARTIAL_ARRIVAL,PAYMENT" },
        CANCEL: { "query#invoiceStatus.EQ": "CANCEL_INVOICING" },
        refundAuditStatus: { "query#refundAuditStatus.EQ": "APPLYING" },
        PENDING_REFUND: { "query#invoiceStatus.EQ": "PENDING_REFUND" },
        REFUND_SUCCESS: { "query#invoiceStatus.EQ": "REFUND_SUCCESS" },
        THREE_MONTHS_UNPAID_INVOICE: { "noPaymentMonth": 3 },
        SIX_MONTHS_UNPAID_INVOICE: { "noPaymentMonth": 6 },
      },
      pageTotal: {
        all: 0, APPLYING: 0, SUCCESS: 0, DEFEAT: 0, PENDING_INVOICE: 0, RECEIVABLES: 0,
        CANCEL: 0, refundAuditStatus: 0, PENDING_REFUND: 0, REFUND_SUCCESS: 0,
        THREE_MONTHS_UNPAID_INVOICE: 0, SIX_MONTHS_UNPAID_INVOICE: 0,
      },
      option: [
        {label: '到款时间', value: 'arrivalTime'},
        {label: '退票申请时间', value: 'refundTime'},
        {label: '退票日期', value: 'refundDate'},
        {label: '退票审核日期', value: 'operatingTime'},
        {label: '开票日期', value: 'invoiceDate'},
        {label: '创建时间', value: 'createTime'},
      ],
      viewDetailIcon: viewDetailIcon,
      contactInfo: [],
      showContactInfo: false,
      loading: true,
      activeTab: 'all',
      checkedCol: [],
      showAddEditDialog: false,
      selectType: {},
      selectDetail: '',
      showAddRecordMail: false,
      paymentsInfos: [],
      claimInfos: [],
      showPayments: false,
      ticketsInfo: {},
      role: '',
    }
  },
  computed: {
    columns() {
      let cols = ticket([] || {});
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  created() {
    this.role = getDataInLocalStorage("role")
  },
  methods: {
    getStatusColor,
    getInvoiceColor,
    exportInvoice,
    loadAllTabTotals() {
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getTicketsPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    claimInvoiceFlag(text) {
      if (!text || text.length === 0) {
        return false
      }
      return text.map(item => item['claimTheInvoiceFlag']).includes(true)
    },
    async openPaymentsInfo(row, flag) {
      try {
        if (flag) {
          let params = { 'page.current': 1, 'page.size': 100 };
          let data = {
            "query#dataKey.IN": row.payments.map(item => item.id).join(','),
            "query#status.EQ": "SUCCESS"
          }
          const response = await getAuditPage(params, data, 'CLAIM_INVOICE_AUDIT')
          if (response.code === 200) {
            this.claimInfos = response.data.records
          }
        }
        this.paymentsInfos = row.payments.filter(item => !item['claimTheInvoiceFlag'])
        this.ticketsInfo = row
        this.showPayments = true
      } catch (error) {
        console.log(error);
        this.$nextTick(() => {
          this.claimInfos = []
          this.paymentsInfos = []
          this.ticketsInfo = {}
          this.showPayments = false
        })
      }
    },
    async download(row, type) {
      try {
        let ids = this.selectable.filter(item => item.appendix).map(item => item.id)
        let data;
        if (row && row.id) {
          data = { "query#id.IN": row.id }
        } else if (row === 'all') {
          data = this.getSearch({ ...this.sendData[this.activeTab] })
        } else {
          if (ids.length <= 0) {
            this.$messageUi.error('请选择需批量下载的发票')
            return
          }
          data = { "query#id.IN": ids.join(',') }
        }
        let timestamp = Math.floor(Date.now() / 1000);
        let url;
        if (type === 'invoice') {
          const response = await downloadBatch(timestamp, data)
          if (response.code === 200) {
            url = `${baseURL}/invoice-info/attachment-batch/${timestamp}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
          } else {
            return
          }
        } else {
          url = `${baseURL}/invoice-record/attachment/${row.invoiceRecordId}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        }
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    getCheckedBox(col, cols) {
      this.checkedCol = col.filter(item => cols.includes(item.title))
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    // 获取发票表数据
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] };
      console.log(this.searchConditionTag)
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getTicketsPage(params, sendData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.currentNum = parseInt(res.data.current);
          this.page.pageSize = parseInt(res.data.size);
          this.page.total = parseInt(res.data.total);
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
      });
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (['refundAuditStatus', 'statusType'].includes(item.key)) {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (item.key === 'invoiceStatus') {
          if (item.value === '待审核') {
            value = 'PENDING_AUDIT'
          } else if (item.value === '待开票') {
            value = 'PENDING_INVOICE'
          } else if (item.value === '应收款') {
            value = 'RECEIVABLES'
          } else if (item.value === '已回款') {
            value = 'PAYMENT'
          } else if (item.value === '退票成功') {
            value = 'REFUND_SUCCESS'
          } else if (item.value === '部分到款') {
            value = 'PARTIAL_ARRIVAL'
          } else if (item.value === '取消开票') {
            value = 'CANCEL_INVOICING'
          } else {
            value = 'PENDING_REFUND'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        } else if (item.key === 'arrivalTime') {
          value = value.split('至').join(',')
        }
        if (['invoiceRecordNumber', 'statusType', 'contractNumber', 'saleName', 'invoicingPrincipal', 'invoiceTitle', 'billingUnitName', 'contactName', 'theAmountReceived', 'arrivalTime', 'initialSalesName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    closeAddEditDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddEditDialog = false
      })
    },
    closeAdd(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showAddRecordMail = false
      })
    },
    closeShowPayments() {
      this.$nextTick(() => {
        this.showPayments = false
      })
      this.paymentsInfos = []
      this.claimInfos = []
      this.ticketsInfo = {}
    },
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        let data = { "query#id.EQ": row.invoiceRecordId }
        getRecordPage({}, data).then(res => {
          if (res.code === 200 && res.data.records.length > 0) {
            this.selectDetail = res.data.records[0]
            this.selectType = { type: 'edit' }
            this.showAddEditDialog = true
          }
        }).catch(res => {
          this.$messageUi.error('获取发票信息失败')
        })
      } else {
        this.showAddRecordMail = true
      }
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showContact(contactName) {
      let data = { "query#contactName.IN": contactName.join(',') }
      getUserPage({}, data).then(res => {
        if (res.code === 200) {
          this.contactInfo = res.data.records
          this.showContactInfo = true
        } else {
          this.showContactInfo = false
        }
      }).catch(err => {
        this.showContactInfo = false
      })
    },
    refund(row) {
      let ids = this.selectable.filter(item => item.refundAuditStatus === null && (item.invoiceStatus === 'RECEIVABLES' || item.invoiceStatus === 'PAYMENT')).map(item => item.id)
      if (row && row.id) {
        ids = [row.id]
      } else {
        if (ids.length <= 0) {
          this.$messageUi.error('批量退票会筛选可退票发票，请勾选要批量退票的数据')
          return
        }
      }
      this.$prompt('请输入退票原因', row ? '确定要申请退票吗?' : '确定要批量申请退票吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '退票原因不可为空',
        closeOnClickModal: false
      }).then(({value}) => {
        let data = { "ids": ids, "refundReason": value }
        refundTickets(data).then(res => {
          if (res.code === 200) {
            this.$store.commit('right/setChangeRed', true)
            this.$messageUi.success('已申请退票!')
            this.selectable = []
            this.getData('search')
          }
        }).catch(err => {})
      }).catch(() => {})
    },
    saleCancel(row) {
      let invoiceIds = this.selectable.filter(item => ['PENDING_INVOICE'].includes(item.invoiceStatus)).map(item => item.id)
      if (row && row.id) {
        invoiceIds = [row.id]
      } else {
        if (invoiceIds.length <= 0) {
          this.$messageUi.error('请勾选要批量取消开票的数据')
          return
        }
      }
      this.$prompt('请输入取消开票原因', row ? '确定要取消开票吗?' : '确定要批量取消开票吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '取消开票原因不可为空',
        closeOnClickModal: false
      }).then(({value}) => {
        let data = { "invoiceIds": invoiceIds, "reason": value }
        saleCancelInvoice(data).then(res => {
          if (res.code === 200) {
            this.$store.commit('right/setChangeRed', true)
            this.$messageUi.success('已取消开票!')
            this.selectable = []
            this.getData('search')
          }
        }).catch(err => {})
      }).catch(() => {})
    },
  }
}
</script>

<style scoped>
</style>
